import type { RouteObject } from "react-router-dom";
export const routes: RouteObject[] = [
  {
    path: "/:lang?",
    lazy: () => import("./components/shared/Lang.gen"),
    handle: "src/components/shared/Lang.gen.tsx",
    children: [{
      path: "seller/",
      lazy: () => import("./components/pages/seller/Seller.gen"),
      handle: "src/components/pages/seller/Seller.gen.tsx",
      children: [
        {
          path: "cart",
          lazy: () => import("./components/routes/CartSearchRoute.gen"),
          handle: "src/components/routes/CartSearchRoute.gen.tsx",
          children: [{
            path: ":id",
            lazy: () => import("./components/routes/CartSummaryRoute.gen"),
            handle: "src/components/routes/CartSummaryRoute.gen.tsx",
            children: [
              {
                path: "pricing",
                lazy: () => import("./components/routes/CartPricingRoute.gen"),
                handle: "src/components/routes/CartPricingRoute.gen.tsx",
              },
              {
                path: "contact",
                lazy: () => import("./components/routes/CartContactRoute.gen"),
                handle: "src/components/routes/CartContactRoute.gen.tsx",
              },
            ],
          }],
        },
        {
          path: "payouts/:id",
          lazy: () => import("./components/routes/PayoutDetailRoute.gen"),
          handle: "src/components/routes/PayoutDetailRoute.gen.tsx",
        },
        {
          path: "payouts",
          lazy: async () =>
            (await import("./components/routes/PayoutsRoute.gen"))
          ,
          handle: "src/components/routes/PayoutsRoute.gen.tsx",
        },
        {
          path: "questions",
          children: [{
            path: ":sku",
            lazy: async () => ({
              Component: (await import("./components/pages/seller/questions")).default,
            }),
            handle: "src/components/pages/seller/questions.tsx",
          }]
        },
        {
          index: true,
          lazy: async () => ({
            Component: (await import("./components/pages/seller/index")).default,
          }),
          handle: "src/components/pages/seller/index.tsx",
        },
      ]
      },

  {
    path: "beta/admin/",
    // lazy: () => import("./components/routes/adminRoutes"),
    // handle: "src/components/routes/adminRoutes.tsx",
    lazy: () => import("./components/pages/admin/Admin.gen"),
    handle: "src/components/pages/admin/Admin.gen.tsx",
    children: [
      {
        path: "shipments",
        lazy: async () => ({
          Component: (await import("./components/pages/admin/shipments")).default,
        }),
        handle: "src/components/pages/admin/shipments.tsx",
      },
      {
        path: "relayTest",
        lazy: () => import("./components/routes/RelayTestRoute"),
        handle: "src/components/routes/relayTestRoute.tsx",
      },
      // {
      //   path: "braintree-test/:id",
      //   lazy: () => import("./components/routes/BraintreePreloadRoute.gen"),
      //   // children: [{
      //   //   path: ":id",
      //   //   lazy: () => import("./components/routes/ViewLoadedCartPriceRoute.gen"),
      //   //   handle: "src/components/routes/ViewLoadedCartPriceRoute.gen.tsx",
      //   // }],
      //   handle: "src/components/routes/BraintreePreloadRoute.gen.tsx",
      // },
      {
        index: true,
        lazy: async () => ({
          Component: (await import("./components/pages/admin/index")).default,
        }),
        handle: "src/components/pages/admin/index.tsx",
      },
    ],
  },
      
      
      {
      path: "",
      lazy: () => import("./components/routes/DefaultLayoutRoute"),
      handle: "src/components/routes/DefaultLayoutRoute.tsx",
      children: [
        {
          index: true,
          lazy: () => import("./components/routes/HomeRoute.gen"),
          handle: "src/components/routes/HomeRoute.gen.tsx",
        },
        {
          // Temporary alias for production testing of the new home page; remove after cutover.
          path: "test-home",
          lazy: () => import("./components/routes/HomeRoute.gen"),
          handle: "src/components/routes/HomeRoute.gen.tsx",
        },
        {
          path: "preview/:assetId",
          lazy: () => import("./components/routes/AIPreviewRoute.gen"),
          handle: "src/components/routes/AIPreviewRoute.gen.tsx",
        },
        {
          // Exact /artists only; /artists/:username profiles are still PHP.
          path: "artists",
          lazy: () => import("./components/routes/ArtistsRoute.gen"),
          handle: "src/components/routes/ArtistsRoute.gen.tsx",
        },
        {
          path: "pet-portraits",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/PetPortraitsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/PetPortraitsPage.gen.tsx",
        },
        {
          path: "baby-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/BabyPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/BabyPaintingsPage.gen.tsx",
        },
        {
          path: "bird-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/BirdPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/BirdPaintingsPage.gen.tsx",
        },
        {
          path: "cat-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/CatPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/CatPaintingsPage.gen.tsx",
        },
        {
          path: "dog-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/DogPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/DogPaintingsPage.gen.tsx",
        },
        {
          path: "horse-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/HorsePaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/HorsePaintingsPage.gen.tsx",
        },
        {
          path: "landscape-paintings",
          lazy: async () => ({
            Component: (
              await import(
                "./components/pages/landing/LandscapePaintingsPage.gen"
              )
            ).default,
          }),
          handle: "src/components/pages/landing/LandscapePaintingsPage.gen.tsx",
        },
        {
          path: "portrait-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/PortraitPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/PortraitPaintingsPage.gen.tsx",
        },
        {
          path: "wedding-paintings",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/WeddingPaintingsPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/WeddingPaintingsPage.gen.tsx",
        },
        {
          path: "ideas",
          // Component: React.lazy(() => import("./components/pages/landing/Ideas_Page.gen")),
          lazy: async () => ({
            Component: (await import("./components/pages/landing/Ideas_Page.gen"))
              .default,
          }),
          handle: "src/components/pages/landing/Ideas_Page.gen.tsx",
        },
        {
          path: "assets",
          lazy: async () => ({
            Component: (
              await import("./components/pages/landing/InstantPreviewPage.gen")
            ).default,
          }),
          handle: "src/components/pages/landing/InstantPreviewPage.gen.tsx",
        },
        // {
        //   path: "/artists/ukraine",
        //   lazy: () => import("./components/routes/UkraineRoute"),
        //   handle: "src/components/routes/UkraineRoute.tsx",
        // },
      ],
    }]
  },
// {
//   path: "/seller/",
//   lazy: () => import("./components/pages/seller/Seller.gen"),
//   handle: "src/components/pages/seller/Seller.gen.tsx",
//   children: [
//     {
//       path: "payouts/:id",
//       lazy: () => import("./components/routes/PayoutDetailRoute.gen"),
//       handle: "src/components/routes/PayoutDetailRoute.gen.tsx",
//     },
//     {
//       path: "payouts",
//       lazy: async () =>
//         (await import("./components/pages/seller/Payouts2.gen"))
//       ,
//       handle: "src/components/pages/seller/Payouts2.gen.tsx",
//     },
//     {
//       path: "questions",
//       children: [{
//         path: ":sku",
//         lazy: async () => ({
//           Component: (await import("./components/pages/seller/questions")).default,
//         }),
//         handle: "src/components/pages/seller/questions.tsx",
//       }]
//     },
//     {
//       index: true,
//       lazy: async () => ({
//         Component: (await import("./components/pages/seller/index")).default,
//       }),
//       handle: "src/components/pages/seller/index.tsx",
//     },
//   ]
//   },
  // {
  //   path: "/beta/admin/",
  //   // lazy: () => import("./components/routes/adminRoutes"),
  //   // handle: "src/components/routes/adminRoutes.tsx",
  //   lazy: () => import("./components/pages/admin/Admin.gen"),
  //   handle: "src/components/pages/admin/Admin.gen.tsx",
  //   children: [
  //     {
  //       path: "shipments",
  //       lazy: async () => ({
  //         Component: (await import("./components/pages/admin/shipments")).default,
  //       }),
  //       handle: "src/components/pages/admin/shipments.tsx",
  //     },
  //     {
  //       path: "relayTest",
  //       lazy: () => import("./components/routes/RelayTestRoute"),
  //       handle: "src/components/routes/relayTestRoute.tsx",
  //     },
  //     // {
  //     //   path: "braintree-test/:id",
  //     //   lazy: () => import("./components/routes/BraintreePreloadRoute.gen"),
  //     //   // children: [{
  //     //   //   path: ":id",
  //     //   //   lazy: () => import("./components/routes/ViewLoadedCartPriceRoute.gen"),
  //     //   //   handle: "src/components/routes/ViewLoadedCartPriceRoute.gen.tsx",
  //     //   // }],
  //     //   handle: "src/components/routes/BraintreePreloadRoute.gen.tsx",
  //     // },
  //     {
  //       index: true,
  //       lazy: async () => ({
  //         Component: (await import("./components/pages/admin/index")).default,
  //       }),
  //       handle: "src/components/pages/admin/index.tsx",
  //     },
  //   ],
  // }
];
